import { CFAuthGetRef } from 'auth';
import { locations } from '../../common/redux/action_locations';
import {
    FETCH_MUS,
    RECEIVED_MUS,
    FETCH_AGENT_SCHEDULES,
    RECEIVED_AGENT_SCHEDULES
} from './constants';

export function fetchAgentSchedulesAction(filters) {
	return {
        type: FETCH_AGENT_SCHEDULES,
        fetchCall: fetchAgentSchedules,
        receivedAction: receivedAgentSchedules,
        data: { 
            locations,
            filters
        }
    }
}

function fetchAgentSchedules(params) {
	return CFAuthGetRef({
		url: process.env.REACT_APP_WFM_API_URL + `/AgentSchedule/AgentScheduleWeek/${params.ManagementUnitID}`,
		params: {
            StartScheduledDayKey: params.StartScheduledDayKey,
            EndScheduledDayKey: params.EndScheduledDayKey
        },
		originURL: process.env.PUBLIC_URL,
		loaderName: 'fetchAgentSchedules'
	})
}

function receivedAgentSchedules(res) {
	return {
		type: RECEIVED_AGENT_SCHEDULES,
        AgentSchedules: res.AgentsScheduleWeek,
        WeekHeaders: res.WeekHeader
	}
}

export function fetchMUsAction() {
	return {
        type: FETCH_MUS,
        fetchCall: fetchMUs,
        receivedAction: receivedMUs,
        data: { locations }
    }
}

function fetchMUs() {
	return CFAuthGetRef({
		url: process.env.REACT_APP_DATA_PROXY_API_URL + '/CCMProxy/GetSecuredManagementUnitDictionary/',
		params: null,
		originURL: process.env.PUBLIC_URL,
		loaderName: 'fetchMUs'
	})
}

function receivedMUs(data) {
	return {
		type: RECEIVED_MUS,
        MUs: data
	}
}

export const clearAgentSchedules = () => {
    return {
		type: 'CLEAR_AGENT_SCHEDULES'
	}
}

export function reducer(state, action) {
	switch (action.type) {
		case RECEIVED_MUS:
		return {
            ...state,
            MUs: action.MUs,
        };
        case RECEIVED_AGENT_SCHEDULES:
        return {
            ...state,
            AgentSchedules: action.AgentSchedules,
            WeekHeaders: action.WeekHeaders
        }
        case 'CLEAR_AGENT_SCHEDULES':
        return {
            ...state,
            AgentSchedules: [],
            WeekHeaders: []
        }
		default:
		return state;
	}
}


// WEBPACK FOOTER //
// ./src/features/schedules/redux/schedules_actions.js